import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "subscription-column-header" }
const _hoisted_2 = { class: "subscription-column-header-top" }
const _hoisted_3 = { class: "subscription-column-heading" }
const _hoisted_4 = { class: "subscription-column-count" }
const _hoisted_5 = ["aria-pressed"]
const _hoisted_6 = {
  key: 1,
  href: "/products",
  class: "subscription-column-continue"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon-md",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-arrow-right" })
], -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "subscription-column-subtitle"
}
const _hoisted_9 = {
  key: 0,
  class: "subscription-column-body"
}
const _hoisted_10 = { class: "subscription-column-cards" }
const _hoisted_11 = {
  key: 0,
  class: "subscription-column-vat-note"
}
const _hoisted_12 = {
  key: 1,
  class: "subscription-column-totals"
}
const _hoisted_13 = { class: "total-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "*", -1 /* HOISTED */)
const _hoisted_15 = { class: "total-row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "*", -1 /* HOISTED */)
const _hoisted_17 = { class: "total-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "**", -1 /* HOISTED */)
const _hoisted_19 = { class: "subscription-column-vat-note" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "*", -1 /* HOISTED */)
const _hoisted_21 = {
  key: 0,
  class: "subscription-column-vat-note subscription-column-evaluation"
}
const _hoisted_22 = { class: "subscription-column-subtotal" }
const _hoisted_23 = {
  key: 0,
  class: "subscription-column-vat-note subscription-column-evaluation"
}
const _hoisted_24 = {
  key: 1,
  class: "subscription-column-empty"
}
const _hoisted_25 = {
  key: 0,
  href: "/products",
  class: "btn btn-primary"
}
const _hoisted_26 = {
  key: 2,
  class: "subscription-column-body"
}
const _hoisted_27 = { class: "subscription-column-cards" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["subscription-column", `subscription-column--${$props.carttype}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          _createTextVNode(_toDisplayString($setup.column_heading) + " ", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.count), 1 /* TEXT */)
        ]),
        ($props.carttype == 'active' && $setup.switch_target_count)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "subscription-column-switch",
              "aria-pressed": $setup.one_off_view,
              onClick: _cache[0] || (_cache[0] = $event => ($setup.one_off_view = !$setup.one_off_view))
            }, _toDisplayString($setup.switch_label), 9 /* TEXT, PROPS */, _hoisted_5))
          : _createCommentVNode("v-if", true),
        ($props.carttype == 'shopping-cart' && $setup.count)
          ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.__("Continue shopping")) + " ", 1 /* TEXT */),
              _hoisted_7
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.subtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.subtitle), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.count)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.subscription_groups, (group) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: group.key
              }, [
                _createVNode($setup["CartCategories"], {
                  category: group.family,
                  start_date: group.start_date
                }, null, 8 /* PROPS */, ["category", "start_date"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                  return (_openBlock(), _createBlock($setup["SubscriptionCard"], {
                    key: item.name,
                    item: item,
                    users: $props.users,
                    readonly: $setup.readonly,
                    evaluation_note: $setup.evaluation_column,
                    variable_price_marker: $props.carttype == 'in-progress',
                    onMinusQty: _cache[1] || (_cache[1] = (i) => $setup.minusQty(i)),
                    onPlusQty: _cache[2] || (_cache[2] = (i) => $setup.plusQty(i)),
                    onRemoveItem: _cache[3] || (_cache[3] = (i) => $setup.removeItem(i))
                  }, null, 8 /* PROPS */, ["item", "users", "readonly", "evaluation_note", "variable_price_marker"]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.guest_unpriced, (item) => {
              return (_openBlock(), _createBlock($setup["GuestCartLine"], {
                key: item.product_id,
                product_id: item.product_id,
                qty: item.qty,
                onRemove: $event => ($setup.remove_guest_line(item.product_id))
              }, null, 8 /* PROPS */, ["product_id", "qty", "onRemove"]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createCommentVNode(" Guest only: stored lines the catalogue no longer returns. Kept with the cart\n\t\t\t\t     lines, before the totals and the order step, so they read as part of the\n\t\t\t\t     cart. Not counted in the badge or the totals. "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.guest_unavailable, (item) => {
              return (_openBlock(), _createBlock($setup["GuestCartLine"], {
                key: item.product_id,
                product_id: item.product_id,
                qty: item.qty,
                note: _ctx.__('This product is no longer available.'),
                onRemove: $event => ($setup.remove_guest_line(item.product_id))
              }, null, 8 /* PROPS */, ["product_id", "qty", "note", "onRemove"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          ($props.carttype == 'shopping-cart')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createCommentVNode(" Totals over a partly priced guest cart would be wrong: the notice replaces them. "),
                ($setup.guest_failed)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.__("Some prices could not be loaded. Refresh the page to try again.")), 1 /* TEXT */))
                  : (_openBlock(), _createBlock($setup["CartTotal"], {
                      key: 1,
                      subscription_object: $props.subscription,
                      carttype: "shopping-cart"
                    }, null, 8 /* PROPS */, ["subscription_object"])),
                _createVNode($setup["CartValidation"], {
                  subscription_object: $props.subscription,
                  onValidate_cart: _cache[4] || (_cache[4] = (vat_number, trial, options) => $setup.validate_cart(vat_number, trial, options)),
                  onRemove_non_eval_items: _cache[5] || (_cache[5] = (line_ids) => $setup.removeNonEvalItems(line_ids)),
                  onGet_subscription: _cache[6] || (_cache[6] = $event => ($setup.emit('get_subscription')))
                }, null, 8 /* PROPS */, ["subscription_object"])
              ], 64 /* STABLE_FRAGMENT */))
            : ($props.carttype == 'in-progress')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h6", null, [
                      _createTextVNode(_toDisplayString(_ctx.__("Total Setup and Purchase")), 1 /* TEXT */),
                      _hoisted_14
                    ]),
                    _createElementVNode("h6", null, _toDisplayString($setup.ioi_format_currency($setup.one_time_total, $props.subscription.currency)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h6", null, [
                      _createTextVNode(_toDisplayString(_ctx.__("Total Subscription")), 1 /* TEXT */),
                      _hoisted_16
                    ]),
                    _createElementVNode("h6", null, _toDisplayString($setup.ioi_format_currency($setup.recurring_total, $props.subscription.currency)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("h6", null, [
                      _createTextVNode(_toDisplayString(_ctx.__("Setup time")), 1 /* TEXT */),
                      _hoisted_18
                    ]),
                    _createElementVNode("h6", null, _toDisplayString($setup.setup_time_total) + " " + _toDisplayString(_ctx.__("Hours")), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.__("Prices exclude VAT")), 1 /* TEXT */),
                    _hoisted_20
                  ]),
                  ($setup.has_evaluation)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.__("Subscription for evaluation, not an effective order")), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createVNode($setup["SetupTimeFootnote"], {
                    subscription_items: $props.subscription.subscription_items
                  }, null, 8 /* PROPS */, ["subscription_items"])
                ]))
              : (!$setup.one_off_view)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createCommentVNode(" No footer in the one-off view: subtotal is recurring-only, so\n\t\t\t     \"Total Subscription\" over a list of one-off lines would be wrong twice\n\t\t\t     over. one_off_view is only ever set by the Active column's switch,\n\t\t\t     so this reads as the plain v-else it replaces everywhere else. "),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("h5", null, _toDisplayString($setup.subtotal_label), 1 /* TEXT */),
                      _createElementVNode("h5", null, _toDisplayString($setup.ioi_format_currency($setup.subtotal, $props.subscription.currency)), 1 /* TEXT */)
                    ]),
                    _createCommentVNode(" Under the subtotal's two-child row, never in it. "),
                    ($setup.has_evaluation)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.__("Subscription for evaluation, not an effective order")), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("h5", null, _toDisplayString($setup.empty_heading), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.empty_body), 1 /* TEXT */),
          ($props.carttype == 'shopping-cart')
            ? (_openBlock(), _createElementBlock("a", _hoisted_25, _toDisplayString(_ctx.__("Browse products")), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])),
    _createCommentVNode(" Guest only, and only when nothing else is in the cart: the lines the catalogue no\n\t\t     longer returns, under the empty state, so the visitor can still remove them.\n\t\t     With other lines present they sit among the cards above instead. "),
    ($setup.guest_unavailable.length && !$setup.count)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.guest_unavailable, (item) => {
              return (_openBlock(), _createBlock($setup["GuestCartLine"], {
                key: item.product_id,
                product_id: item.product_id,
                qty: item.qty,
                note: _ctx.__('This product is no longer available.'),
                onRemove: $event => ($setup.remove_guest_line(item.product_id))
              }, null, 8 /* PROPS */, ["product_id", "qty", "note", "onRemove"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}